import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// récupérer toutes les filiéres
export const getAllFilieres = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/filiere/getAllFilieres`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer une filière par son id
export const getFiliereById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/filiere/getFiliereById/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// créer une filière
export const createFiliere = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/filiere/create`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
// modifier une filière
export const updateFiliere = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/filiere/update/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// supprimer une filière
export const deleteFiliere = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/filiere/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
